import { useEffect, useMemo, useRef } from 'react'

import { type Column, Table } from '../../../../../../components/Table'
import { useInfiniteScroll } from '../../../../../../hooks/useInfiniteScroll'
import { useInfiniteExpertsQuery } from '../../../../../../services/hooks/experts/queries/useExpertQuery'
import { type FiltersDomain } from '../../../../../../types/domain/filters-domain'
import { type ExpertDomain } from '../../../../../../types/domain/expert-domain'
import type PaginationDomain from '../../../../../../types/domain/pagination-domain'
import { mapExpertDomainDataToTableRow } from '../utils/mapExpertDomainDataToTableRow'

type Props = {
  filters: FiltersDomain
  columns: Column[]
}

export const TableWithInfiniteScroll = ({ filters, columns }: Props) => {
  const tableContainerRef = useRef<HTMLDivElement>(null)

  const {
    data,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  } = useInfiniteExpertsQuery(filters)

  const rows = useMemo(() => {
    return data?.pages
      ?.reduce(
        (acc: ExpertDomain[], { data }: PaginationDomain<ExpertDomain>) => {
          return [...acc, ...data]
        },
        []
      )
      .map(mapExpertDomainDataToTableRow)
  }, [data])

  useInfiniteScroll(tableContainerRef, hasNextPage, fetchNextPage)

  useEffect(() => {
    refetch()
  }, [])

  return (
    <Table
      columns={columns}
      rows={rows || []}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      tableContainerRef={tableContainerRef}
      noContentMessage="Sem registro de expert(s)"
      paginationMode="scroll"
    />
  )
}
